import { Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Check } from "@phosphor-icons/react";
import React, { useEffect } from "react"
import { useState } from "react";
import { PROFILE_SETUP_FORMS, PROFILE_SETUP_STEPS } from "../../../enums/profileSetupEnums";

export const ProfileSetupStepper = ({ selectedSetupForm }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (selectedSetupForm) {
      setCurrentStep(PROFILE_SETUP_STEPS?.[selectedSetupForm])
    }
  }, [selectedSetupForm])

  const CustomStepIcon = (props) => {
    const { active, completed } = props;

    return (
      <Box
        component="span"
        sx={{
          zIndex: 1,
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: '3px solid',
          borderColor: active || completed ? 'primary.main' : '#C4CDD5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: completed ? '#FFF' : active ? 'primary.main' : '#C4CDD5',
          fontSize: '14px',
          fontWeight: 700,
          backgroundColor: completed ? 'primary.main' : active && 'transparent',
        }}
      >
        {completed ? <Check size={16} weight="bold" /> : props.icon} {/* Show number or check icon */}
      </Box>
    );
  }

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 15,
      marginLeft: -5,
      marginRight: -5,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.primary.main,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.primary.main,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#C4CDD5',
      borderTopWidth: 3
    },
  }));

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Stepper
        activeStep={currentStep}
        alternativeLabel
        connector={<CustomConnector />}
      >
        {
          PROFILE_SETUP_FORMS?.map((step, index) => {
            const isActive = currentStep === index;
            const isCompleted = currentStep > index;
            return (
              <Step key={`step-key-${index}`}>
                <StepLabel StepIconComponent={CustomStepIcon}>
                  <Typography
                    fontSize={{ xs: '10px', sm: '14px' }}
                    color={isCompleted ? '#637381' : isActive ? 'primary' : '#C4CDD5'}
                    sx={{
                      whiteSpace: {
                        xs: 'normal',
                        sm: 'nowrap',
                      },
                    }}
                  >
                    {step?.label}
                  </Typography>
                </StepLabel>
              </Step>
            )
          })
        }
      </Stepper>
    </Box>
  )
}